<template>
	<div class="item-details-section">
		<div v-if="imageURL" class="image-wrapper" tabindex="0" :aria-label="`Image of ${title} ${description}`">
			<img class="image" :src="imageURL" :alt="title" />
		</div>
		<div class="add-item-details">
			<div v-if="isAlcohol" class="alcohol-indicator" tabindex="0" aria-label="Alcohol">
				<img
					v-if="isAlcohol"
					:src="$CDN + '/images/alcohol.svg'"
					title="Alcohol"
					alt="Alcohol icon"
					class="icon alcohol-icon"
				/>Alcohol
			</div>
			<div class="icons-section-wrapper">
				<div v-for="allergy in allergyIcons" :key="allergy.icon" class="icon-wrapper">
					<icon-base height="20" width="20" class="icon" :iconName="allergy.label" tabindex="0">
						<component :is="allergy.icon" />
					</icon-base>
					&nbsp;{{ allergy.label }}
				</div>
			</div>
			<div class="add-item-menu-description" v-if="description">
				{{ description }}
			</div>
			<div v-if="price" class="add-item-price" tabindex="0" :aria-label="'$' + price">${{ price }}</div>
		</div>
	</div>
</template>

<script>
import IconBase from "../IconBase.vue";
import IconCarrot from "../icons/IconCarrot.vue";
import IconGF from "../icons/IconGF.vue";
import IconSpicy from "../icons/IconSpicy.vue";
import IconV from "../icons/IconV.vue";

export default {
	name: "AddItemDetails",
	components: {
		IconBase,
		IconCarrot,
		IconGF,
		IconSpicy,
		IconV,
		IconBase,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		description: String,
		price: [String, Number],
		imageURL: {
			type: String,
			default: "",
		},
		isAlcohol: {
			type: Boolean,
			default: false,
		},
		allergyIcons: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.item-details-section {
	text-align: center;
	margin-bottom: 25px;
}

.add-item-header-bottom {
	font-size: 16px;
	font-weight: 400;
}

.add-item-menu-description {
	margin-bottom: 5px;
}

.image-wrapper {
	width: 90%;
	height: 100%;
	margin: auto;
}

.image {
	width: 100%;
	max-height: 50vh;
	object-fit: scale-down;
	border-radius: $border-radius;
}

.add-item-details {
	font-size: 16px;
	font-weight: 400;
}

.add-item-price {
	font-size: 20px;
}

.alcohol-indicator {
	font-size: 14px;
	font-weight: 700;
	padding: 5px !important;
	background-color: #ffd71b !important;
	border-radius: 22.5px;
	box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
	display: flex;
	justify-content: center;
	width: 30%;
	margin: 5px auto;
	align-items: center;
}

.alcohol-icon {
	height: auto;
	width: 15px;
	margin-right: 5px;
}

.icons-section-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 12px;
	font-weight: 500;
	margin-bottom: 5px;
}

.icon-wrapper {
	display: flex;
	align-items: center;
	margin-right: 5px;
}
</style>
